import { AuditEventCategory, AuditItem, AuditItemResponseDTO } from "@dto/auditResponse.dto";
import { DateUtil } from "@dto/util/DateUtil";
import { RangePickerProps } from "antd/es/date-picker";
import TabPane from "antd/es/tabs/TabPane";
import { useEffect, useState } from "react";
import XmTabsSticky from "src/component/stickyTab/XmTabsSticky";
import useDebounce from "src/hook/useDebounce";
import useGetApiData from "src/hook/useGetApiData";
import AuditDatePicker from "./AuditLogDatePicker";
import AuditTable, { TableData } from "./AuditLogTable";

const toSeconds = (time: Date) => (Math.round(time.getTime() / 1000));
const oneDayRange = (): { start: Date, end: Date; } => {
  const end = new Date();
  const start = new Date(end);
  start.setDate(start.getDate() - 1);
  return { start, end };
};

const AuditLog = () => {
  const [tab, setTab] = useState<AuditEventCategory>(AuditEventCategory.SYSTEM);
  const [tableData, setTableData] = useState<TableData[]>([]);
  const [apiParams, setApiParams] = useState<{ start: Date, end: Date; }>(oneDayRange());
  const debouncedApiParams = useDebounce(apiParams);
  const [isTimeSet, setIsTimeSet] = useState(true);
  const [data, , loading] = useGetApiData<AuditItem[], AuditItemResponseDTO>(
    `/api/audit/v1?start=${toSeconds(apiParams.start)}&end=${toSeconds(apiParams.end)}`,
    "Get Logs failed",
    [debouncedApiParams],
    []
  );

  useEffect(() => {
    const tableDataFiltered = data
      .filter(log => log.category === tab)
      .map((event, value) => ({
        ...event,
        rowKey: value,
        inSeconds: toSeconds(new Date(event.time)),
        time: DateUtil.getDateISO(new Date(event.time)),
      }));

    setTableData(tableDataFiltered);
  }, [data, tab]);


  const handleRangeChange: RangePickerProps['onChange'] = (values) => {
    if (!values) {
      setIsTimeSet(false);
      return;
    }

    setIsTimeSet(true);
    setApiParams({ start: values[0].toDate(), end: values[1].toDate() });
  };

  return (
    <XmTabsSticky
      defaultActiveKey={AuditEventCategory.SYSTEM}
      onChange={(key) => setTab(key as AuditEventCategory)}
      activeKey={tab}
    >
      <TabPane tab="System Configuration" key={AuditEventCategory.SYSTEM} >
        <div className="audit-container">
          <AuditTable data={tableData} allData={tableData} loading={loading} />
          <AuditDatePicker
            isTimeSet={isTimeSet}
            startDate={apiParams.start}
            endDate={apiParams.end}
            onChange={handleRangeChange}
          />
        </div>
      </TabPane>
      <TabPane tab="User Settings" key={AuditEventCategory.USER}>
        <div className="audit-container">
          <AuditTable data={tableData} allData={tableData} loading={loading} />
          <AuditDatePicker
            isTimeSet={isTimeSet}
            startDate={apiParams.start}
            endDate={apiParams.end}
            onChange={handleRangeChange}
          />
        </div>
      </TabPane>
    </XmTabsSticky>
  );
};

export default AuditLog;